<template>
    <v-container>
        <v-row v-if="!$vuetify.breakpoint.mobile">
            <v-col cols="9">
                <ts-nft v-model="nft" v-if="premint_id" :premint_id="premint_id"></ts-nft>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col cols="3">
                <v-container>
                    <ts-nft-widget-chest hover class="mb-4" v-model="chest"></ts-nft-widget-chest>
                    <ts-nft-widget-price hover class="my-4" :nft-component="nft" v-model="price"></ts-nft-widget-price>
                    <ts-nft-widget-share hover class="my-4" :nft-component="nft"></ts-nft-widget-share>
                </v-container>
            </v-col>
        </v-row>
        <div v-else>
            <v-alert class="text-caption" :icon="mdiInformation" dense type="info">
                The BraNFT™ Store interface is currently best suited for the desktop environment.
            </v-alert>
        </div>
        <v-row v-if="!premint_id && !$vuetify.breakpoint.mobile">
            <v-col cols="12" class="d-flex justify-center text-caption">
                Create your first BraNFT™ to use this panel.
            </v-col>
        </v-row>
    </v-container>
</template>
<style scoped>
.active-nft-slide {
    border-radius: 5px;
}
</style>
<script>
import TsNft from './TsNft.vue';
import TsNftWidgetChest from "./TsNftWidgetChest.vue";
import TsNftWidgetPrice from "./TsNftWidgetPrice.vue";
import TsNftWidgetShare from "./TsNftWidgetShare.vue";
import { mdiInformation } from '@mdi/js';

export default {
    name: "TsNftSellPanel",
    components: {
        TsNft,
        TsNftWidgetChest,
        TsNftWidgetPrice,
        TsNftWidgetShare,
    },
    methods: {
    },
    data() {
        return {
            chest: {},
            price: null,
            nft: null,
            mdiInformation,
        }
    },
    computed: {
        premint_id() {
            return this.chest && this.chest.top ? this.chest.top.premint_id : undefined;
        }
    },
    mounted() {
    }
};
</script>
